import api from '@/api/api.js';

class AuthService {
  getUserInfo(wpToken) {
    return api.getUserInfo(wpToken).then(async response => {
    const user = JSON.parse(localStorage.getItem('user'));
    const { iat = null, expires_in = null } = user || {};
      if (response.data.data) {
        const updatedUser = {
          ...response.data.data.wp_user,
          jwt_token: response.data.data.wp_token ? response.data.data.wp_token : user.jwt_token,
          iat: iat,
          expires_in: expires_in,
          token_type: 'Bearer',
        };
        localStorage.setItem('user', JSON.stringify(updatedUser));
    
        return updatedUser;
      }

      return user;
    });
  }
  integrateUseme(integrationData) {
    return api.integrateUseme({ integrationData });
  }
  updateBilling(billingData) {
    return api.updateBilling(
      {
        billing_address_1: billingData.address,
        billing_address_2: billingData.address_2,
        billing_first_name: billingData.billing_first_name,
        billing_last_name: billingData.billing_last_name,
        billing_company: billingData.billing_company,
        billing_city: billingData.city,
        billing_state: billingData.billing_state,
        billing_postcode: billingData.postcode,
        billing_country: billingData.billing_country,
        billing_email: billingData.billing_email,
        billing_phone: billingData.phone_number,
      }
    );
  }
  updateGlobalSaleSettings(data) {
    return api.updateGlobalSaleSettings(data);
  }
  updateEventPhotoSettings(data) {
    return api.updateEventPhotoSettings(data);
  }
  updatePhotographerProfile(data) {
    return api.updatePhotographerProfile(data);
  }
  login(user) {
    return api
      .userLogin({
        email: user.email,
        password: user.password,
      })
      .then(response => {
        const larToken = response.data.data.lar_token,
              wpToken = response.data.data.wp_token,
              profile = response.data.data.profile;

        localStorage.setItem('larToken', JSON.stringify(larToken));
        const userData = {
          ...wpToken,
          ...profile,
        };

        localStorage.setItem('user', JSON.stringify(userData));

        return userData;
      });
  }
  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('larToken');
    localStorage.removeItem('cities');
    localStorage.removeItem('events');
    localStorage.removeItem('unverifiedEvents');
    localStorage.removeItem('currentEvent');
  }
  register(user) {
    return api.userRegistration({
      username: user.username,
      email: user.email,
      phoneNumber: user.phoneNumber,
      password: user.password,
      referralGear: user.gear,
      referralNumber: user.runnerNumber,
      accountType: user.accountType,
      portfolio: user.portfolio,
    });
  }
  registerPhotographerByOrganizer(user) {
    return api.registerPhotographerByOrganizer({
      username: user.username,
      email: user.email,
      portfolio: user.portfolio
    });
  }
  sendResetLink(email) {
    return api.sendResetLink(email);
  }
  resetPassword(email, key, newPassword, newPasswordConfirmation) {
    return api.resetPassword(email, key, newPassword, newPasswordConfirmation);
  }
  refreshToken() {
    return api
      .refreshToken()
      .then((response) => {
        const tokens = response.data.data;
        localStorage.setItem('larToken', JSON.stringify(tokens.lar_token));

        return tokens;
      })
      .catch((error) => {
        this.logout();

        throw error;
      });
  }
}

export default new AuthService();
